"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIIconRating = _interopRequireDefault(require("UIComponents/input/UIIconRating"));

var _ReviewerInfo = _interopRequireDefault(require("./ReviewerInfo"));

var ReviewCard = function ReviewCard(_ref) {
  var company = _ref.company,
      rating = _ref.rating,
      reviewDate = _ref.reviewDate,
      reviewText = _ref.reviewText,
      userAvatarUrl = _ref.userAvatarUrl,
      userFullName = _ref.userFullName;
  return _react.default.createElement(_UICardWrapper.default, {
    compact: true
  }, _react.default.createElement(_UICardSection.default, null, _react.default.createElement(_UIFlex.default, {
    justify: "between"
  }, _react.default.createElement(_UIBox.default, null, _react.default.createElement(_Small.default, {
    className: "secondary-text"
  }, _I18n.default.moment.utc(reviewDate).format('LL'))), _react.default.createElement(_UIBox.default, null, _react.default.createElement(_UIIconRating.default, {
    disabled: true,
    iconSize: "xxs",
    value: rating
  })))), _react.default.createElement(_UICardSection.default, null, _react.default.createElement("p", null, reviewText)), _react.default.createElement(_UICardSection.default, null, _react.default.createElement(_ReviewerInfo.default, {
    company: company,
    userAvatarUrl: userAvatarUrl,
    userFullName: userFullName
  })));
};

ReviewCard.propTypes = {
  company: _react.PropTypes.string,
  rating: _react.PropTypes.number.isRequired,
  reviewDate: _react.PropTypes.number.isRequired,
  reviewText: _react.PropTypes.string.isRequired,
  userAvatarUrl: _react.PropTypes.string.isRequired,
  userFullName: _react.PropTypes.string.isRequired
};
var _default = ReviewCard;
exports.default = _default;
module.exports = exports.default;